import React, { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
    useEffect(() => {
        // Always force light theme — remove 'dark' class if present
        document.documentElement.classList.remove('dark');
        localStorage.setItem('theme', 'light');
    }, []);

    return (
        <ThemeContext.Provider value={{ theme: 'light', toggleTheme: () => {}, isLoading: false }}>
            {children}
        </ThemeContext.Provider>
    );
};
